/* eslint-disable */
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserAdministrationDetailsResponseDto, fixUserAdministrationDetailsResponseDtoFromJson } from '../dto/user-administration-details-response-dto';
import { ZvooveProblemDetails } from '../dto/zvoove-problem-details';

export interface GetCustomerUserAdministrationZvooveUserIdDetailsRouteParams {
  zvooveUserId: string;
}

export interface GetCustomerUserAdministrationZvooveUserIdDetailsParams {
  route: GetCustomerUserAdministrationZvooveUserIdDetailsRouteParams;
}

export function httpGetCustomerUserAdministrationZvooveUserIdDetails(http: HttpClient, data: GetCustomerUserAdministrationZvooveUserIdDetailsParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<UserAdministrationDetailsResponseDto>;
export function httpGetCustomerUserAdministrationZvooveUserIdDetails(http: HttpClient, data: GetCustomerUserAdministrationZvooveUserIdDetailsParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<UserAdministrationDetailsResponseDto>>;
export function httpGetCustomerUserAdministrationZvooveUserIdDetails(http: HttpClient, data: GetCustomerUserAdministrationZvooveUserIdDetailsParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get<UserAdministrationDetailsResponseDto>(`{placeholder}/customer/user/administration/${data.route.zvooveUserId}/details`, options as any).pipe(
    tap((eventOrDto) => {
      const dto = eventOrDto instanceof HttpResponse ? eventOrDto.body : options.observe === 'events' ? null : eventOrDto as unknown as UserAdministrationDetailsResponseDto;
      fixUserAdministrationDetailsResponseDtoFromJson(dto);
    })
  );
};

export const urlGetCustomerUserAdministrationZvooveUserIdDetails = (baseUrl: string, data: GetCustomerUserAdministrationZvooveUserIdDetailsParams) => {
  return `${baseUrl}/customer/user/administration/${data.route.zvooveUserId}/details`;
};
